export default "__VITE_ASSET__C4$yNrhn__"